import React from 'react';
import { Form } from 'react-bootstrap';
import './ToggleComponent.css';

interface Toggleprops {
  switchName: string;
  Disabled: boolean;
  switchId: string;
  onToggleChange: (checked: boolean) => void;
  checked: boolean;
  isRequired?: boolean;
  switchOnOffNames: string[];
}

const ToggleComponent: React.FC<Toggleprops> = ({
  switchName,
  Disabled,
  switchId,
  onToggleChange,
  checked,
  isRequired,
  switchOnOffNames,
}) => {
  const handleChange = () => {
    onToggleChange(!checked);
  };
  return (
    <div className="custom_toggle_switch">
      {switchName && (
        <label
          className={`switch_label-name-from-parent ${isRequired && 'yes'} `}
        >
          {switchName}
        </label>
      )}
      <div className="inside_toggle_form">
        <Form>
          <Form.Check
            className="custom-switch"
            type="switch"
            disabled={Disabled}
            id={switchId}
            onChange={handleChange}
            checked={checked}
          />
        </Form>

        {checked ? (
          <span className={`custom_switch_span_names ${Disabled}`}>
            {switchOnOffNames[0]}
          </span>
        ) : (
          <span className={`custom_switch_span_names ${Disabled}`}>
            {switchOnOffNames[1]}
          </span>
        )}
      </div>
    </div>
  );
};
export default ToggleComponent;
